module.exports = __webpack_public_path__ + "static/dl-iphone@2x-2cb8e105924f087ee61e2746c1a1334e.png";